import type { UseStore } from 'zustand';
import shallow from 'zustand/shallow';
import { useEffect, useMemo } from 'react';
import type { EhsFormioSVSSelectStore } from './EhsFormioSVSSelect';
import type { infrastructurePortalUtil } from 'generated-ts-common';
import { createOtherOption } from './FormioSVSUtil';

type GenCode = infrastructurePortalUtil.saf.infrastructure.model.svs.GenCode;

export function useLoadSVSSelectStoreData({
  valueSetOid,
  includeOther = false,
  store
}: {
  valueSetOid: string;
  includeOther?: boolean;
  store?: UseStore<EhsFormioSVSSelectStore>;
}) {
  const [storeData, loadSVSValues, isLoading] = store?.(
    (state: { data: any; load: any; isLoading: any }) => [
      state.data,
      state.load,
      state.isLoading
    ],
    shallow
  ) ?? [{}, () => null, () => false]; // empty state when the store is not set yet

  // automatically load the items, if the url is initialized properly
  useEffect(() => {
    if (!storeData[valueSetOid]) {
      loadSVSValues(valueSetOid);
    }
  }, [storeData, loadSVSValues, valueSetOid]);

  const items: Array<GenCode> = useMemo(() => storeData[valueSetOid] ?? [], [
    valueSetOid,
    storeData
  ]);

  const selectItems: Array<GenCode> = useMemo(() => {
    return includeOther ? [...items, createOtherOption()] : items;
  }, [items, includeOther]);

  return { storeData, items, selectItems, isLoading };
}
